import mediaQueries from '../helpers/mediaQueries.js';
import '@geit/ui-components';
import colours from './colours.js';
import fonts from './fonts.js';
import grid from './grid.js';
const theme = {
  colours,
  fonts,
  // spacing: spacing,
  media: mediaQueries(grid.breakpoints),
  // styles: styles,
  grid
  // states: states,
};

export { theme as default };